<script lang="ts">
    
    import { createEventDispatcher } from "svelte";    
    import { Button, FormGroup, Label, TabContent, TabPane } from "sveltestrap";
    import type { Room } from "../../Model/Room";
    import { roomsService } from "../../Services";
    import { i18n } from "../../Services/i18n";
    import MessagesManager from "../Messages/MessagesManager.svelte";
    import Checkbox from "../Shared/Checkbox.svelte";

    export let roomId: string;

    const dispatch = createEventDispatcher();

    let isSaving = false;
    let room: Room;

    $: setupRoom(roomId);

    async function setupRoom(roomId: string): Promise<void> {
        try {
            room = await roomsService.getRoom(roomId);
        } catch (error) {
            console.error(error);
        }
    }

    async function onSubmit(): Promise<void> {
        if (!room || isSaving) {
            return;
        }
        isSaving = true;
        try {
            await roomsService.saveRoom(room);
            dispatch('saved', room);
        } catch (error) {
            console.error(error);
        } finally {
            isSaving = false;
        }
    }

</script>

<form on:submit|preventDefault={onSubmit}>
    <TabContent>
        <TabPane tab={$i18n("Premios")} tabId="rewards" active class="pt-3">
            {#if room}
                <FormGroup>
                    <Label>{$i18n("PREMIO LÍNEA/FIGURA")}</Label>
                    <input type="text" class="form-control" bind:value={room.roomRewards.figure.text.value}>
                </FormGroup>
                <FormGroup>
                    <Label>{$i18n("PREMIO BINGO")}</Label>
                    <input type="text" class="form-control" bind:value={room.roomRewards.bingo.text.value}>
                </FormGroup>
                <FormGroup>
                    <Checkbox checked={room.showRoomQrInMonitor} label={$i18n("Mostrar QR y PIN")} />
                </FormGroup>
            {/if}
        </TabPane>
        <TabPane tab={$i18n("Mensajes")} tabId="messajes" class="pt-3">
            <MessagesManager {roomId} />
        </TabPane>
    </TabContent>

    <hr>

    <Button type="submit" color="primary" disabled={!room || isSaving}>{$i18n("Guardar")}</Button>

</form>
